export const handlePriorityList = [
  'recovery-support-pack',
  '1st-trimester-prenatal-pack',
  '2nd-trimester-prenatal-pack',
  '3rd-trimester-prenatal-pack',
  '1st-trimester-prenatal-powder',
  'mom-multi-support-pack',
  'conception-support-pack',
  'mens-multi-support-pack',
  'womens-daily-vitamin-trio',
  'egg-freeze-support-pack',
];
